/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { PutPerCoursePriceTenantData } from './PutPerCoursePriceTenantData';
import { PutTenantWidePriceTenantData } from './PutTenantWidePriceTenantData';
const PutPriceTenantDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    PutPerCoursePriceTenantData,
    PutTenantWidePriceTenantData,
]);
export const PutPriceTenantData = PutPriceTenantDataParser;
